<script setup lang="ts">
defineProps<{
  html: string;
}>();
</script>

<template>
  <div class="mbw-form-failure">
    <div>
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="17" stroke="#C0392B" stroke-width="2" />
        <path d="M12 12L24 24M24 12L12 24" stroke="#C0392B" stroke-width="3" stroke-linecap="round" />
      </svg>
    </div>
    <div class="mbw-form-failure-heading">Błąd</div>
    <div class="mbw-form-failure-text" v-html="html" />
  </div>
</template>
